import { PostItem as PostItemV3 } from "@/react/components/PostsV3/PostViewList/PostItem";
import { EventViewListItem } from "@circle-react/components/Events/EventViewItem";
import { isEventPost } from "@circle-react/helpers/postHelpers";

export const ViewItem = ({ ...props }: any) => {
  if (isEventPost(props.post)) {
    // TODO: event doesn't exist on EventViewListItemProps, after TS migration, fix this.
    return <EventViewListItem {...props} event={props.post} />;
  }

  return <PostItemV3 {...props} forcePostView usedIn="home" />;
};
